import { DbMongoBaseInfos } from "./db-mongo-base-infos";
import { PurgeMethod } from "./purge-method";
import { ObjectType } from "./object-type";
import { ObjectStatus } from "./object-status";
import { FilePurgeHistory } from "./file-purge-history";
import { DbMetadataFieldInfos } from "./db-metadata-field-infos";
import { DbMetadataFieldValueInfos } from "./db-metadata-field-value-infos";
import { IDbBaseMetadataValueInfos } from "./i-db-base-metadata-value-infos";

export class DbFilePurgeRuleInfos extends DbMongoBaseInfos {
  enabled: boolean = false;
  deleteFileEntry: boolean = false;
  platformId: number | null = 0;
  reachedDays: number = 0;
  method: PurgeMethod | null = null;
  name: string | null = null;
  checkOnlineCopyOnStorageId: number | null = 0;
  purgeOrphanFiles: boolean = false;
  storageIds: number[] | null = null;
  formatIds: number[] | null = null;
  objectTypes: ObjectType[] | null = null;
  objectStatuses: ObjectStatus[] | null = null;
  objectMetadata: IDbBaseMetadataValueInfos[] | null = null;
  histories: FilePurgeHistory[] | null = null;
  passObjectToStatus: ObjectStatus | null = null;

  constructor(init?: Partial<DbFilePurgeRuleInfos>) {
    super();
    Object.assign(this, init);
  }
}
